import ebrc from './templates/ebrc.json';
import ed5q from './templates/ed5q.json';
import eus from './templates/eus.json';
import ipaq from './templates/ipaq.json';
import qald from './templates/qald.json';
import iife5 from './templates/iife5.json';
import sde from './templates/sde.json';

const questionnaires = [
    {
        uuid: ebrc.id,
        name: 'Escala de Barreiras de Reabilitação Cardíaca',
        description:
            'Avaliação da percepção relativamente ao programa de reabilitação cardíaca.',
        data: ebrc
    },
    {
        uuid: ed5q.id,
        name: 'Avaliação de Ganhos em Saude.',
        description: 'Avaliação da percepção relativamente aos Ganhos em Saúde.',
        data: ed5q
    },
    {
        uuid: eus.id,
        name: 'Escala de Utilização de Sistema tecnológico',
        description:
            'Avaliação da percepção relativamente a utilização do sistema tecnológico.',
        data: eus
    },
    {
        uuid: ipaq.id,
        name: 'Questionário Internacional de Atividade Fisica',
        description: 'Avaliaçã da atividade física habitual.',
        data: ipaq
    },
    {
        uuid: qald.id,
        name: 'Avaliação da Literacia Digital',
        description: 'Avaliação do acesso e competencias em tecnologias de informação.',
        data: qald
    },
    {
        uuid: iife5.id,
        name: 'Disfunção Erétil',
        description: 'Avaliação do Grau de Disfunção Eretil.',
        data: iife5
    },
    {
        uuid: sde.id,
        name: 'Dados Sociodemográficos e económicos',
        description:
            'Recolha de informação sociodemográfica e económica para contextualizar o acompanhamento do paciente.',
        data: sde
    }
];

export default questionnaires;
